export const LOADING = 'myDashboard.LOADING';
export const LOADED = 'myDashboard.LOADED';

export const LOADINGPAGEDATA = 'myDashboard.LOADINGPAGEDATA';
export const LOADEDPAGEDATA = 'myDashboard.LOADEDPAGEDATA';

export const DELETING = 'myDashboard.DELETING';
export const DELETED = 'myDashboard.DELETED';